import { PageLayout } from "@/components/templates/page-layout";
import { SiteForm } from "@/components/organisms/site-form";
import { useSites } from "@/core/hooks/useSites";

export default function NouveauSitePage() {
  const { createSite } = useSites();

  return (
    <PageLayout title="Nouveau site">
      <SiteForm
        onSubmit={async (data) => {
          await createSite(data);
        }}
      />
    </PageLayout>
  );
}
